<template>
    <div class="pay">
        <div class="pay-container">
            <div class="pay-top">
                <div class="pay-top-left">订单提交成功,请尽快付款!</div>
                <div class="pay-top-right">应付金额<span>¥{{pay_info.money || 0}}</span></div>
            </div>
            <div class="pay-body">
                <div class="pay-body-title">
                    <img :src="pay_icon" alt="" class="title-icon" />
                    <div class="title-text">{{ type == 'wechat' ? '微信支付' : '支付宝支付' }}</div>
                </div>
                <div class="pay-tips">
                    距离二维码过期还剩<span>{{ count_down }}</span>秒,过期后请刷新页面重新获取二维码
                </div>
                <div class="pay-qrcode-body">
                    <div class="pay-qrcode-box">
                        <div class="pay-qrcode">
                            <img v-if="pay_info.pay_code" :src="pay_info.pay_code" alt="" />
                            <Spin size="large" v-else></Spin>
                        </div>
                        <div class="pay-qrcode-tips">
                            <img src="@/assets/images/icon-mall-scan.png" alt="" class="scan-icon">
                            <div class="scan-tips">
                                <div>请使用支付宝扫一扫</div>
                                <div>扫描二维码支付</div>
                            </div>
                        </div>
                    </div>
                    <div :class="['pay-bg',{alipay:type === 'alipay','wechat':type === 'wechat'}]"></div>
                </div>
                <div v-if="false" class="back-to-choose">
                    <Icon type="ios-arrow-back" />
                    选择其他支付方式
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { CheckMallPayStatus, orderPay } from '@/api/index';
import QRCode from 'qrcode';
export default{
    data() {
        return {
            type:'wechat',
            uuid:'',
            count_down:0,
            pay_info:{},
            pay_check:null,
        }
    },
    computed:{
        pay_icon(){
            return this.type == 'wechat' ? 
            require('../../assets/images/icon-mall-wechat-pay.png') : 
            require('../../assets/images/icon-mall-alipay.png');
        }
    },
    mounted() {
        const {pay_type,uuid} = this.$route.query;
        if(pay_type){
            this.type = pay_type;
        }
        if(uuid){
            this.uuid = uuid;
        }
        this.onOrderPay();
    },
    beforeRouteLeave(to,from,next){
        this.stopPayPolling();
        next();
    },
    beforeDestroy(){
        this.stopPayPolling();
    },
    methods: {
        stopPayPolling(){
            if(this.pay_check){
                clearInterval(this.pay_check);
                this.pay_check = null;
            }
        },
        async onOrderPay(){
            try{
                const {code,msg,data} = await orderPay({
                    pay_type:this.type,
                    uuid:this.uuid
                })
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                // this.$layer.msg(msg);
                console.log('pay_res',data);
                let payQrcode;
                QRCode.toDataURL(data.url,{width:252,height:252}).then(url=>{
                    payQrcode = url;
                    console.log('qrcode===>',url);
                }).finally(() => {
                    this.pay_info = {...data,pay_code:payQrcode};
                    console.log('pay-info',this.pay_info);
                    this.count_down = 360;
                    this.stopPayPolling();
                    this.pay_check = setInterval(() => {
                        if(this.count_down < 1){
                            this.stopPayPolling();
                            window.location.reload();
                            return;
                        }
                        this.count_down--;
                        CheckMallPayStatus({ uuid:this.uuid }).then((res) => {
                            if (res.data.status === 1) {
                                this.stopPayPolling();
                                this.$layer.msg('支付成功');
                                this.$router.push({name:"MallPayResult", query:{uuid:this.uuid}})
                            }
                        });
                    }, 1000)
                })
            }catch(e){
                console.warn('err-order-pay',e);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.pay{
    width:100%;
    min-height:100vh;
    background:rgb(246,247,250);
    display:flex;
    justify-content:center;
    padding-bottom:100px;
    .pay-container{
        width:1560px;
        background:#ffffff;
        padding:0 70px;
        display:flex;
        flex-direction:column;
        margin-top:32px;
        .pay-top{
            width:100%;
            border-bottom:1px solid #dbdbdb;
            padding:40px 0 30px 0;
            display:flex;
            align-items:center;
            justify-content:space-between;
            .pay-top-left{
                color:#333333;
                font-size:16px;
            }
            .pay-top-right{
                color:#333333;
                font-size:14px;
                display:flex;
                align-items:center;
                column-gap:16px;
                span{
                    color:#fa3d5a;
                    font-size:20px;
                    font-weight:bold;
                }
            }
        }
        .pay-body{
            width:100%;
            display:flex;
            flex-direction:column;
            margin-top:25px;
            padding-bottom:80px;
            .pay-body-title{
                display:flex;
                align-items:center;
                column-gap:10px;
                .title-icon{
                    width:32px;
                    height:32px;
                }
                .title-text{
                    color:#333333;
                    font-size:26px;
                }
            }
            .pay-tips{
                color:#999999;
                font-size:14px;
                margin-top:20px;
                span{
                    color:#fa3d5a;
                }
            }
            .pay-qrcode-body{
                width:100%;
                display:flex;
                justify-content:center;
                margin-top:66px;
                column-gap:121px;
                .pay-qrcode-box{
                    display:flex;
                    flex-direction:column;
                    row-gap:20px;
                    width:270px;
                    .pay-qrcode{
                        width:100%;
                        height:270px;
                        border:1px solid #e3e3e3;
                        img{
                            width:100%;
                            height:100%;
                        }
                        display:flex;
                        align-items:center;
                        justify-content:center;
                    }
                    .pay-qrcode-tips{
                        width:100%;
                        background:#fa3d5a;
                        color:#ffffff;
                        display:flex;
                        justify-content:center;
                        align-items:center;
                        column-gap:11px;
                        padding:18px 0;
                        .scan-icon{
                            width:36px;
                            height:34px;
                        }
                        .scan-tips{
                            display:flex;
                            flex-direction:column;
                            font-size:14px;
                        }
                    }
                }
                .pay-bg{
                    width:250px;
                    height:321px;
                    background-size:cover;
                    background-repeat:no-repeat;
                    background-position:center;
                    &.alipay{
                        background-image:url('../../assets/images/bg-mall-alipay.png');
                    }
                    &.wechat{
                        background-image:url('../../assets/images/bg-mall-wechat-pay.png');
                    }
                }
            }
            .back-to-choose{
                margin-top:94px;
                display:flex;
                align-items:center;
                column-gap:10px;
                color:#575859;
                font-size:14px;
                margin-bottom:104px;
                cursor:pointer;
            }
        }
    }
}
</style>